// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

// Components Imports
import SelectedSheetComponent from "./SelectedSheetComponent";

// Internal Imports
// import { DocumentUtils } from "../../utils";

// Selectors Imports
import {
  selectLinkedExcelTableComponent,
  selectExcelSheetId,
} from "../../selectors/quotationsSelectors";

// Destructuring
// const { checkSectionIsLinkedToExcel } = DocumentUtils;

class ExcelCatalog extends Component {
  state = {
    selectedWorkSheet: "",
    selectedRangeValue: "",
    selectedRangeValueStartedChanging: false,
  };

  componentDidMount() {
    if (
      this.props.rowData &&
      this.props.rowData.data &&
      this.props.rowData.data.attributes &&
      this.props.rowData.data.attributes.connected
    ) {
      this.setState({
        selectedWorkSheet: this.props.rowData.data.attributes.currentSheetName,
        selectedRangeValue: this.props.rowData.data.attributes.rangeValue,
      });
    }
  }

  componentDidUpdate(prevProps) {
    this._stateUpdateHandling(prevProps);
  }

  _updateMultipleState = obj => {
    this.setState({
      ...obj,
    });
  };

  _stateUpdateHandling = prevProps => {
    if (
      this.props.rowData &&
      this.props.rowData.data &&
      this.props.rowData.data.attributes
    ) {
      const {
        data: {
          attributes: { connected, rangeValue, currentSheetName },
        },
      } = this.props.rowData;

      if (
        this.props.excelSheetSectionId !== prevProps.excelSheetSectionId &&
        connected
      ) {
        this.setState({
          selectedWorkSheet: currentSheetName,
          selectedRangeValue: rangeValue,
        });
      } else if (
        this.props.excelSheetSectionId === prevProps.excelSheetSectionId &&
        this.props.currentGSheet.workSheet === this.state.selectedWorkSheet &&
        this.state.selectedRangeValue === "" &&
        rangeValue !== "" &&
        this.state.selectedRangeValueStartedChanging === false
      ) {
        this.setState({
          selectedRangeValue: rangeValue,
        });
      } else if (
        this.props.excelSheetSectionId !== prevProps.excelSheetSectionId &&
        !connected
      ) {
        this.setState({
          selectedWorkSheet: "",
          selectedRangeValue: "",
        });
      }
    }
  };

  _changeSheetData = () => {
    this.setState({
      // selectedSheet: {},
      selectedWorkSheet: "",
      selectedRangeValue: "",
      selectedRangeValueStartedChanging: false,
    });
  };

  _upatedExcelSheetTable = fileName => {
    this.setState({
      selectedWorkSheet: fileName,
      selectedRangeValue: "",
      selectedRangeValueStartedChanging: false,
    });
  };

  _setRangeValue = e => {
    console.debug("_setRangeValue", e.target.value);
    this.setState({
      selectedRangeValueStartedChanging: true,
      selectedRangeValue: e.target.value.trim().toUpperCase(),
    });
  };

  _upatedSelectedRangeValueStatus = () => {
    this.setState({
      selectedRangeValueStartedChanging: false,
    });
  };

  render() {
    const {
      // selectedSheet,
      // sheetEditMode,
      selectedWorkSheet,
      selectedRangeValue,
    } = this.state;
    return (
      <Fragment>
        <div className="excelsheet-cataglog-container animated fadeinright">
          <div className="excelsheet-cataglog-sheet-container">
            <SelectedSheetComponent
              sheetData={this.props.rowData}
              selectedWorkSheet={selectedWorkSheet}
              selectedRangeValue={selectedRangeValue}
              docId={this.props.docId}
              mode={this.props.mode}
              changeSheetData={this._changeSheetData}
              upatedExcelSheetTable={this._upatedExcelSheetTable}
              setRangeValue={this._setRangeValue}
              upatedSelectedRangeValueStatus={
                this._upatedSelectedRangeValueStatus
              }
              excelSheetId={this.props.excelSheetSectionId}
              updateMultipleState={this._updateMultipleState}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { currentGSheetTab } = state.GoogleSheetStore;
  const currentGSheet = currentGSheetTab;
  const { sheet, workSheet, rangeValue } = currentGSheet || {};
  const excelSheetId = selectExcelSheetId(state);
  let rowData = null;
  if (excelSheetId) {
    rowData = selectLinkedExcelTableComponent(state);
  }
  return {
    excelSheetSectionId: excelSheetId,
    rowData,
    currentGSheet,
    sheet,
    workSheet,
    rangeValue,
  };
};

export default connect(mapStateToProps, null)(ExcelCatalog);
